import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "cb8e2d9d-dc3d-4342-a75d-4c22c26cec92",
    content: "Increased if we add some absorption material on the ceilling.",
    options: {},
  },
  {
    id: "1fb696c5-0558-4838-a189-6d9afb71e2da",
    content: "Decreased if we add some absorption material on the side wall.",
    options: {},
  },
  { id: "5cab9e90-b44e-4faf-9149-fd5f86a43b61", content: "The sound pressure level will be the same.", options: {} },
  {
    id: "f4efb916-08b6-4051-97d2-2754b9ce163a",
    content: "The sound pressure level does not depend on the amount of absorption in the receiving room.",
    options: {},
  },
];

export const task: Task = {
  id: "89cf2fe5-4cd3-4661-94d6-2dd952bfd728",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["1fb696c5-0558-4838-a189-6d9afb71e2da"],
};
